import { AutomationStep, AutomationStepWithChildren } from '@/types/automationSteps.ts';
import { Group, Stack, Text } from '@mantine/core';
import StyledInputErrorText from '@/components/StyledInputFields/StyledInputErrorText.tsx';
import React from 'react';
import useStepSpecificError from '@/hooks/useStepSpecificError.ts';
import { StepErrorType } from '@/types/stepErrorTypes.ts';
import StepCardTitle from '@/components/StepCard/StepCardTitle.tsx';
import { useHover } from '@mantine/hooks';
import { useActiveStep } from '@/layouts/AutomationPageWrapper/hooks/useActiveStep.ts';

type props = {
  step: AutomationStepWithChildren;
  childrenSteps: AutomationStep[];
  childIndex?: number;
  label: string;
};

const ChildStepsSection = ({ step, childrenSteps, childIndex, label }: props) => {
  const noChildSteps = useStepSpecificError(step, StepErrorType.NoChildSteps, childIndex);

  return (
    <>
      {/*<Divider my={'6px'} />*/}
      <Stack p={'md'} pb={'xl'}>
        <Stack
          m={'-8px'}
          p={'8px'}
          style={{
            backgroundColor: noChildSteps ? '#fdeded' : 'transparent',
            border: noChildSteps ? '1px solid #f34f52' : 'undefined',
            borderRadius: '6px',
          }}
          gap={'xs'}
        >
          <Stack gap={'2px'} mb={'2px'}>
            <Text fw={500} size={'13px'}>
              {label}
            </Text>
            {noChildSteps && <StyledInputErrorText>{noChildSteps}</StyledInputErrorText>}
          </Stack>
          {childrenSteps.map((step, index) => (
            <ChildStep key={index} step={step} />
          ))}
        </Stack>
      </Stack>
    </>
  );
};

type ChildStepProps = {
  step: AutomationStep;
};

const ChildStep = ({ step }: ChildStepProps) => {
  const { hovered, ref } = useHover();
  const { setActiveStep } = useActiveStep();
  return (
    <Group
      style={{
        background: hovered ? '#F7F7F7' : '#FFFFFF',
        borderRadius: '5px',
        border: '1px solid #ECECED',
        cursor: 'pointer',
      }}
      py={'5px'}
      px={'12px'}
      gap={'xs'}
      ref={ref}
      onClick={() => setActiveStep(step.step_id)}
      wrap={'nowrap'}
      // w={'max-content'}
      w={'300px'}
    >
      <StepCardTitle step={step} showLabel={false} iconSize={24} />

      <Text fw={500} truncate={'end'} title={step.name}>
        {step.name}
      </Text>
    </Group>
  );
};

export default ChildStepsSection;
